import React, { Component } from "react";
import {
  ChatListingTypes,
  ConversationStatus,
} from "constants/ChatListingConstants";
import "./ChatListing.scss";
import ChatCard from "components/ChatCard/ChatCard";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { sortBy } from "lodash";
import CollapsibleTabs from "components/CollapsibleTabs/CollapsibleTabs";
import { getUsername } from "utils/Common";

class ChatListing extends Component {
  static propTypes = {
    conversations: PropTypes.array.isRequired,
    agentId: PropTypes.string.isRequired,
    activeConversationId: PropTypes.string,
    transferredConversations: PropTypes.array,
  };
  constructor() {
    super();
    this.state = {
      activeTab: ChatListingTypes.ACTIVE,
    };
    this.currentAgentId = getUsername();
  }

  getActiveChatCardDetails = () => {
    const { conversations } = this.props;
    const activeConversations = conversations.filter((c) => {
      return (
        c.agentId === this.currentAgentId &&
        (c.status === ConversationStatus.OPEN ||
          c.status === ConversationStatus.AUTO_CLOSURE)
      );
    });
    const transformedConversations = activeConversations.map((con) => {
      const lastMsg = con.messages.length
        ? con.messages[con.messages.length - 1]
        : "";
      return {
        conversationId: con.conversationId,
        mobile: con.conversationMeta.phoneNumber,
        customerId: con.conversationMeta.customerId,
        name: con.conversationMeta.name,
        disposition: "",
        lastMsg: lastMsg.message,
        city: con.conversationMeta.city,
        conversation: con,
      };
    });
    const sortedActiveConversations = sortBy(
      transformedConversations,
      (d) => d.conversation.conversationMeta.endTime
    );
    return sortedActiveConversations;
  };

  getInActiveChatDetails = () => {
    const { conversations } = this.props;
    const closedConversations = conversations.filter(
      (c) =>
        c.status === ConversationStatus.CLOSED &&
        c.conversationMeta.endTime &&
        moment().isSame(moment(c.conversationMeta.endTime), "day")
    );

    const transformedConversations = closedConversations.map((con) => {
      const startTime = moment(con.conversationMeta.startTime);
      const endTime = moment(con.conversationMeta.endTime);

      const conversationDuration = moment.duration(endTime.diff(startTime));
      const hours = conversationDuration.hours();
      const mins = conversationDuration.minutes();
      const seconds = conversationDuration.seconds();
      const hoursToDisplay = parseInt(hours) < 10 ? `0${hours}` : hours;
      const minsToDisplay = parseInt(mins) < 10 ? `0${mins}` : mins;
      const secondsToDisplay = parseInt(seconds) < 10 ? `0${seconds}` : seconds;

      const durationToDisplay = `${hoursToDisplay}:${minsToDisplay}:${secondsToDisplay}`;

      return {
        conversationId: con.conversationId,
        mobile: con.conversationMeta.phoneNumber,
        customerId: con.conversationMeta.customerId,
        name: con.conversationMeta.name,
        disposition: con.conversationMeta.disposition,
        subDisposition: con.conversationMeta.subDisposition,
        city: con.conversationMeta.city,
        duration: durationToDisplay,
        conversation: con,
      };
    });

    const sortedClosedConversations = sortBy(
      transformedConversations,
      (d) => d.conversation.conversationMeta.endTime
    ).reverse();

    return sortedClosedConversations;
  };
  renderChatListingWithCards = (chats, isClosed, isTransferredFrom = false) => {
    return chats.map((chat) => (
      <ChatCard
        key={chat.conversationId}
        chatDetails={chat}
        isClosed={isClosed}
        isTransferredFrom={isTransferredFrom}
        isTransferredTo={chat.conversation.chatTransferDetails?.length > 0}
      />
    ));
  };
  onTabClick = (selectedTab) => {
    const { activeTab } = this.state;
    if (activeTab === selectedTab) {
      selectedTab = null; //Collapsing the tab if the same tab is clicked again.
    }
    this.setState({
      activeTab: selectedTab,
    });
  };

  getSelectedConversationStatus = () => {
    const {
      conversations,
      activeConversationId,
      transferredConversations,
      activeConversationStatus,
    } = this.props;
    let selectedConversation = conversations.find(
      (c) =>
        c.conversationId === activeConversationId &&
        c.status === activeConversationStatus
    );
    if (selectedConversation) {
      return selectedConversation.status;
    }
    selectedConversation = transferredConversations.find(
      (c) =>
        c.conversationId === activeConversationId &&
        c.status === activeConversationStatus
    );
    return selectedConversation ? selectedConversation.status : null;
  };

  isTabHighlighted = (listingType) => {
    const selectedConversationStatus = this.getSelectedConversationStatus();
    switch (listingType) {
      case ChatListingTypes.ACTIVE:
        return (
          selectedConversationStatus === ConversationStatus.OPEN ||
          selectedConversationStatus === ConversationStatus.AUTO_CLOSURE
        );
      case ChatListingTypes.CLOSED:
        return selectedConversationStatus === ConversationStatus.CLOSED;
      case ChatListingTypes.TRANSFERRED:
        return selectedConversationStatus === ConversationStatus.TRANSFERRED;
      default:
        return false;
    }
  };

  getTransferredChats = () => {
    return this.props.transferredConversations.map((con) => ({
      conversationId: con.conversationId,
      customerId: con.conversationMeta.customerId,
      mobile: con.conversationMeta.phoneNumber,
      name: con.conversationMeta.name,
      disposition: null,
      subDisposition: null,
      city: con.conversationMeta.city,
      duration: null,
      conversation: con,
    }));
  };

  getChatsListingTabs = () => {
    const { activeTab } = this.state;
    const activeChats = this.getActiveChatCardDetails();
    const inactiveChats = this.getInActiveChatDetails();
    const transferredChats = this.getTransferredChats();
    const highlightedClass = "highlighted";
    return [
      {
        value: ChatListingTypes.ACTIVE,
        content: (
          <div className="chats-listing active-chats-listing">
            {this.renderChatListingWithCards(activeChats, false)}
          </div>
        ),
        active: activeTab === ChatListingTypes.ACTIVE,
        label: "Active chats",
        count: activeChats.length,
        className: this.isTabHighlighted(ChatListingTypes.ACTIVE)
          ? highlightedClass
          : "",
      },
      {
        value: ChatListingTypes.CLOSED,
        content: (
          <div className="chats-listing closed-chats-listing">
            {this.renderChatListingWithCards(inactiveChats, true)}
          </div>
        ),
        active: activeTab === ChatListingTypes.CLOSED,
        label: "Closed chats (Today)",
        count: inactiveChats.length,
        className: this.isTabHighlighted(ChatListingTypes.CLOSED)
          ? highlightedClass
          : "",
      },
      {
        value: ChatListingTypes.TRANSFERRED,
        content: (
          <div className="chats-listing transferred-chats-listing">
            {this.renderChatListingWithCards(transferredChats, true, true)}
          </div>
        ),
        active: activeTab === ChatListingTypes.TRANSFERRED,
        label: "My Transferred Chats (Today)",
        count: transferredChats.length,
        className: this.isTabHighlighted(ChatListingTypes.TRANSFERRED)
          ? highlightedClass
          : "",
      },
    ];
  };
  render() {
    return (
      <CollapsibleTabs
        className="chat-listing-collapsible-tabs"
        tabs={this.getChatsListingTabs()}
        onChange={this.onTabClick}
        data-testid="chat-listing"
      />
    );
  }
}

const mapStateToProps = (state) => ({
  conversations: state.conversation.conversations,
  activeConversationId: state.conversation.activeConversationId,
  activeConversationStatus: state.conversation.activeConversationStatus,
  transferredConversations: state.conversation.transferredConversations,
});

export default connect(mapStateToProps)(ChatListing);
